import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Login submitted:', formData);
    // Add your login logic here
  };

  return (
    <>
      <div>
        <section className="overflow-hidden">
          <Header variant="light" />
        </section>
      </div>

      <section className="py-12 lg:py-24 relative overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="max-w-md mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-5xl sm:text-6xl tracking-xs mb-6">Login</h1>
              <p className="text-lg text-gray-700">
                Welcome back! Please login to your account.
              </p>
            </div>
            <div className="p-8 bg-white rounded-2xl shadow-md">
              <form onSubmit={handleSubmit}>
                <label className="block pl-4 mb-1 text-sm font-medium" htmlFor="email">
                  Email
                </label>
                <input
                  className="w-full px-4 py-3 mb-6 outline-none ring-offset-0 focus:ring-2 focus:ring-lime-500 shadow rounded-full"
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <label className="block pl-4 mb-1 text-sm font-medium" htmlFor="password">
                  Password
                </label>
                <input
                  className="w-full px-4 py-3 mb-6 outline-none ring-offset-0 focus:ring-2 focus:ring-lime-500 shadow rounded-full"
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <div className="flex items-center justify-between mb-6">
                  <label className="flex items-center">
                    <input type="checkbox" className="mr-2" />
                    <span className="text-sm">Remember me</span>
                  </label>
                  <a href="#!" className="text-sm text-teal-900 hover:text-lime-600">
                    Forgot password?
                  </a>
                </div>
                <button
                  type="submit"
                  className="flex w-full py-3 px-5 items-center justify-center font-medium text-white hover:text-teal-900 border border-teal-900 hover:border-lime-500 bg-teal-900 hover:bg-lime-500 rounded-full transition duration-200"
                >
                  <span className="mr-2">Login</span>
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.25 10H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M10.5 4.75L15.75 10L10.5 15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                  </svg>
                </button>
              </form>
              <p className="text-center mt-6 text-sm text-gray-700">
                Don't have an account?{' '}
                <Link to="/register" className="text-teal-900 hover:text-lime-600 font-medium">
                  Sign up
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Login;
